import { getFormattedNumber } from 'src/utils/translation.js';

/**
 * @param {'from'|'to'} boundary
 * @param {string} [optionsKey]
 * @param {string} filterKey
 */
export const paymentBoundaryTitle = (
  boundary,
  optionsKey = 'currencies',
  filterKey = 'currency',
) => {
  return ({ options, filters, value }) => {
    const payment = getFormattedNumber(value);
    const currency = options[optionsKey].find(
      (item) => item.value === filters[filterKey],
    ).title;

    return `${boundary === 'from' ? 'От' : 'До'} ${payment} ${currency}`;
  };
};

/**
 * @param {string} fromKey
 * @param {string} toKey
 * @param {string} [optionsKey]
 * @param {string} filterKey
 */
export const paymentRangeTitle = (
  fromKey,
  toKey,
  optionsKey = 'currencies',
  filterKey = 'currency',
) => {
  return ({ options, filters, value }) => {
    const paymentFrom = getFormattedNumber(value);
    const currency = options[optionsKey].find(
      (item) => item.value === filters[filterKey],
    ).title;
    const hasTo = filters[toKey] !== null;
    if (hasTo) {
      const paymentTo = getFormattedNumber(filters[toKey]);
      return `От ${paymentFrom} до ${paymentTo} ${currency}`;
    }
    return `От ${paymentFrom} ${currency}`;
  };
};

/**
 * @param {'from'|'to'} boundary
 * @param {string} prefix
 */
export const ageBoundaryTitle = (boundary, prefix = '') => {
  return ({ value }) => {
    const measure = value % 10 === 1 ? 'года' : 'лет'

    return `${prefix}${boundary === 'from' ? 'от' : 'до'} ${value} ${measure}`;
  };
};

/**
 * @param {string} fromKey
 * @param {string} toKey
 * @param {string} prefix
 */
export const ageRangeTitle = (fromKey, toKey, prefix = '') => {
  return ({ filters, value }) => {
    const valueFrom = value;
    const measureFrom = value % 10 === 1 ? 'года' : 'лет'
    const hasTo = filters[toKey] !== null;
    if (hasTo) {
      const valueTo = filters[toKey];
      const measureTo = valueTo % 10 === 1 ? 'года' : 'лет'
      if (measureTo === measureFrom) return `${prefix}от ${valueFrom} до ${valueTo} ${measureTo}`;
      return `${prefix}от ${valueFrom} ${measureFrom} до ${valueTo} ${measureTo}`;
    }
    return `${prefix}от ${valueFrom} ${measureFrom}`;
  };
};
